type ActiveIkServoSession = {
  stop: () => void;
};

let activeServoSession: ActiveIkServoSession | null = null;
let activeServoSessionKey: string | null = null;

export function stopActiveServoSession() {
  try {
    activeServoSession?.stop?.();
  } catch {
    // ignore
  }
  activeServoSession = null;
  activeServoSessionKey = null;
}

export function isIkServoSessionActive(): boolean {
  return activeServoSession != null;
}

export function getActiveServoSessionKey(): string | null {
  return activeServoSessionKey;
}

export function setActiveServoSessionKey(key: string | null) {
  activeServoSessionKey = key;
}

export function setActiveServoSession(session: ActiveIkServoSession | null) {
  activeServoSession = session;
}
